import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { HaloIdProvider } from "./auth";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HaloIdProvider>
      <App />
    </HaloIdProvider>
  </React.StrictMode>
);
